<div fxFill fxLayout="column" fxLayoutAlign="center center">
  <h1>Welcome Page</h1>
  <p>If you are not redirected to the editor automatically, you can open it <a href="{{environment.applicationBaseUrl + '/editor'}}">here</a>.</p>
</div>
